import classNames from 'classnames';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled(FormattedHTMLMessage).withConfig({
  displayName: "QuizTopbar__Title",
  componentId: "rpqs58-0"
})(["strong{font-weight:500;}"]);
const QuizTopbar = ({
  numQuestions,
  topRightComponent,
  className,
  currentQuestion
}) => /*#__PURE__*/_jsxs("div", {
  className: classNames('quiz-topbar', className),
  children: [/*#__PURE__*/_jsx(Title, {
    "data-test-id": "quiz-topbar__quiz-question-readout",
    "data-test-info-num-questions": numQuestions,
    message: "learningCenter.quiz.progress",
    options: {
      current: currentQuestion,
      total: numQuestions
    }
  }), topRightComponent]
});
export default QuizTopbar;